export default __webpack_public_path__ + "assets/images/logo_footer.8b0da6de.png";